import React from "react";
import { Text } from "@pushpress/shared-components";
import { AppointmentCredit } from "../PlanDrawer.types";
import ColorSquare from "../../../../components/common/ColorSquare/ColorSquare";
import { formatCurrency } from "../../../../utils/currencyUtils";
import styles from "./AppointmentCard.module.scss";

type Button = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

interface AppointmentCardProps extends Button {
  appointmentCredit: AppointmentCredit;
}

const AppointmentCard = (props: AppointmentCardProps) => {
  const { appointmentCredit, ...other } = props;

  const { quantity, expirationDays, value, appointmentType } =
    appointmentCredit;

  return (
    <button {...other} className={styles.root}>
      <ColorSquare
        color={appointmentCredit.appointmentType.color}
        className={styles.colorSquare}
        size="small"
      />
      <Text
        variant="body-lg"
        weight="600"
        color="wolf-800"
        className={styles.title}
      >
        {appointmentType?.name ?? "--"}
      </Text>
      <Text
        variant="body-md"
        weight="400"
        color="wolf-600"
        className={styles.description}
      >
        <span>{`${quantity} credits`}</span>
        <span>{`${expirationDays} day expiration`}</span>
        {value !== undefined && value !== null && (
          <span>{`${formatCurrency(value)} payroll value`}</span>
        )}
      </Text>
    </button>
  );
};

export default AppointmentCard;
